require(
      "!../../node_modules/gatsby-module-loader/patch.js"
    );
    module.exports = function(cb) { return require.ensure([], function(_, error) {
        if (error) {
          console.log('bundle loading error', error)
          cb(true)
        } else {
          cb(null, function() { return require("!!../../node_modules/json-loader/index.js!./data-visualization-data-visualization-with-d-3-use-the-d-3-max-and-d-3-min-functions-to-find-minimum-and-maximum-values-in-a-dataset.json") })
        }
      }, "path---data-visualization-data-visualization-with-d-3-use-the-d-3-max-and-d-3-min-functions-to-find-minimum-and-maximum-values-in-a-dataset");
     }
    


//////////////////
// WEBPACK FOOTER
// ./~/gatsby-module-loader?name=path---data-visualization-data-visualization-with-d-3-use-the-d-3-max-and-d-3-min-functions-to-find-minimum-and-maximum-values-in-a-dataset!./.cache/json/data-visualization-data-visualization-with-d-3-use-the-d-3-max-and-d-3-min-functions-to-find-minimum-and-maximum-values-in-a-dataset.json
// module id = 1971
// module chunks = 231608221292675